module.exports = __webpack_public_path__ + "img/store-sample.06582b97.png";